import { format } from "date-fns";

export const formattedDate = (data) => {
    const date = new Date(data);
    const formattedDate = format(date, "dd MMMM yyyy");
    return formattedDate;
  };